(function ($) {

  function getPageFromURL() {
    const params = new URLSearchParams(window.location.search);
    return parseInt(params.get('page') || 1, 10);
  }

  function updateURL(page) {
    const url = new URL(window.location.href);
    url.searchParams.set('page', page);
    window.history.pushState({ page }, '', url);
  }

  function fetchPage($block, page, replace = false) {
    const nonce   = $block.data('blog-nonce');
    const payload = JSON.parse($block.attr('data-blog-payload'));

    $.ajax({
      url: window.ajaxurl,
      type: 'POST',
      data: {
        action: 'blog_load_more',
        nonce,
        page,
        payload
      },
      beforeSend() {
        $block.addClass('is-loading');
      },
      success(res) {
        if (!res.success) return;

        const $target = $block.find('.blog__ajax-target');
        replace ? $target.html(res.data.html) : $target.append(res.data.html);

        $block.data('page', page);
        updateURL(page);

        if (!res.data.has_more) {
          $block.addClass('is-end');
        }
      },
      complete() {
        $block.removeClass('is-loading');
      }
    });
  }

  // Pagination click
  $(document).on('click', '.pagination a', function (e) {
    const $pagination = $(this).closest('.pagination');
    const $block = $('[data-blog-block="' + $pagination.data('blog-block') + '"]');

    if (!$block.data('blog-ajax')) return;

    e.preventDefault();
    fetchPage($block, parseInt($(this).data('page'), 10), true);
  });

  // Load more
  $(document).on('click', '[data-load-more]', function () {
    const $block = $(this).closest('[data-blog-block]');
    const next = ($block.data('page') || 1) + 1;
    fetchPage($block, next);
  });

  // Infinite scroll
  $('[data-pagination-mode="infinite"], [data-pagination-mode="hybrid"]').each(function () {
    const sentinel = this.querySelector('.pagination__sentinel');
    if (!sentinel) return;

    const observer = new IntersectionObserver(entries => {
      if (!entries[0].isIntersecting) return;

      const $block = $('[data-blog-block="' + this.dataset.blogBlock + '"]');
      const next = ($block.data('page') || 1) + 1;
      fetchPage($block, next);
    }, { rootMargin: '200px' });

    observer.observe(sentinel);
  });

})(jQuery);
